export const WithoutBoardIcon = ({
  width = '24',
  height = '24',
  fill = '#0F2664',
}) => {
  return (
    <div className="feature">
      <svg
        width={width}
        height={height}
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M16 2L13.7 4.3C13.1503 4.86079 12.8424 5.61474 12.8424 6.4C12.8424 7.18526 13.1503 7.93921 13.7 8.5L15.5 10.3C16.0608 10.8497 16.8147 11.1576 17.6 11.1576C18.3852 11.1576 19.1392 10.8497 19.7 10.3L22 8"
          stroke={fill}
          strokeWidth="0.7"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M15 15L3.29998 3.29999C2.90086 3.69104 2.58379 4.15781 2.36733 4.67294C2.15086 5.18807 2.03937 5.74122 2.03937 6.29999C2.03937 6.85875 2.15086 7.4119 2.36733 7.92704C2.58379 8.44217 2.90086 8.90893 3.29998 9.29999L10.6 16.6C11.3 17.3 12.6 17.3 13.4 16.6L15 15ZM15 15L22 22"
          stroke={fill}
          strokeWidth="0.7"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M2.09998 21.8L8.49998 15.5"
          stroke={fill}
          strokeWidth="0.7"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M19 5L12 12"
          stroke={fill}
          strokeWidth="0.7"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </div>
  );
};
